import {
  firstDayOfMonthDate,
  getFirstAvailableWeek,
  startOfDayDate,
} from '@epicuro-next/utilities';
import {
  DeliveryWindowType,
  InventoryItem,
  OrderType,
} from 'graphql-api/gql-api-interfaces';
import { DateTime } from 'luxon';

import { DeliveryPeriodType } from '../models';

import { isTrueDemandInventory } from './true-demand-inventory';

// tslint:disable-next-line:cognitive-complexity
export function inventoryFilter(
  orderType: OrderType | null,
  deliveryPeriod: string | null,
  currentDeliveryPeriodType: DeliveryPeriodType | undefined,
  deliveryWindow?: DeliveryWindowType,
  // will true if size run enabled
  filterTrueDemand = false,
) {
  return (inv: InventoryItem) => {
    if (filterTrueDemand && isTrueDemandInventory(inv.inventoryId)) {
      return false;
    }
    const isNone = orderType === OrderType.None;
    const isNowOrNone = isNone || orderType === OrderType.Now;
    const quantity = inv.quantity ?? Number.POSITIVE_INFINITY;

    if (quantity && (inv.orderType === orderType || isNone)) {
      if (isNowOrNone) {
        return true;
      }

      const availabilityDateFn =
        currentDeliveryPeriodType === DeliveryPeriodType.Bulk
          ? getBulkAvailabilityDate
          : getAvailabilityDate(deliveryWindow);
      const { from, to } = availabilityDateFn(inv);
      // tackles use-case when inventory and deliveryPeriod (12pm Future tile)
      // are having different timestamps so some of inventories could be omitted
      const deliveryPeriodDate = startOfDayDate(
        !!deliveryPeriod ? new Date(deliveryPeriod) : new Date(),
      );

      const fromDate =
        deliveryWindow === DeliveryWindowType.Month
          ? DateTime.fromJSDate(firstDayOfMonthDate(from))
          : startOfDayDate(from);

      return (
        startOfDayDate(to) >= deliveryPeriodDate &&
        fromDate <= deliveryPeriodDate
      );
    }

    return false;
  };
}

export const getAvailabilityDate =
  (deliveryWindow?: DeliveryWindowType) => (inv: InventoryItem) => {
    // this function was involved in some tricky check-inventory-date issues
    // if you came here to fix yet another issue... well, be careful and good luck!

    const week = getFirstAvailableWeek(
      new Date(inv.displayFromDateUtc ?? inv.availableFromDateUtc),
    );

    const month = firstDayOfMonthDate(
      new Date(inv.displayFromDateUtc ?? inv.availableFromDateUtc),
    );

    return {
      from: deliveryWindow === DeliveryWindowType.Month ? month : week,
      to: new Date(inv.displayToDateUtc ?? inv.availableToDateUtc),
    };
  };

export function getBulkAvailabilityDate(inv: InventoryItem) {
  const week = getFirstAvailableWeek(new Date(inv.availableFromDateUtc));

  return {
    from: week,
    to: new Date(inv.availableToDateUtc),
  };
}
